import { EnvironmentProviders } from '@angular/core';
import { providePrimeNG } from 'primeng/config';

import { getPrimengTranslation } from '@shared/i18n';

import { luma } from './theme';

/**
 * Shared PrimeNG provider for Pulse tenant apps.
 */
export function providePulsePrimeNG(): EnvironmentProviders {
  return providePrimeNG({
    ripple: true,
    theme: {
      preset: luma,
      options: {
        darkModeSelector: '.luma-dark'
      }
    },
    translation: getPrimengTranslation(),
    zIndex: {
      // Below --z-layout-header (1000), above --z-blockui (890). ZIndexUtils starts at base + 1.
      overlay: 900,
      menu: 900,
      // Align with --z-modal.
      modal: 1200,
      tooltip: 1100
    }
  });
}
